import axios from '@fs/zion-axios'

const BASE_GROUPS_PATH = '/service/dmc/groups'

export function getGroupSummary(groupId) {
  return axios.get(`${BASE_GROUPS_PATH}/${groupId}/summary`)
}

export function getGroupChanges(groupId) {
  return axios.get(`${BASE_GROUPS_PATH}/${groupId}/changes`)
}

export function getGroupTreeContributions(treeId, filterBy, values, nextPageToken) {
  const params = {
    filterBy: filterBy || undefined,
    fromChangeId: nextPageToken,
    pageSize: 200,
  }
  const valuesParamString = values && values.length > 0 ? `?value=${values.join('&value=')}` : ''
  return axios.get(`${BASE_GROUPS_PATH}/${treeId}/contributions${valuesParamString}`, { params })
}

export function deleteGroup(groupId) {
  return axios.delete(`${BASE_GROUPS_PATH}/${groupId}`)
}

export function updateGroupProperties(groupId, groupUpdateProperties) {
  return axios.post(`${BASE_GROUPS_PATH}/${groupId}`, groupUpdateProperties)
}

export function getGroupReservations(groupId) {
  return axios.get(`${BASE_GROUPS_PATH}/${groupId}/reservations`)
}

export function shareReservationsToGroup(groupId, reservationIds) {
  return axios.post(`${BASE_GROUPS_PATH}/${groupId}/reservations/${reservationIds}`)
}

export function unshareGroupReservations(groupId, reservationIds) {
  return axios.delete(`${BASE_GROUPS_PATH}/${groupId}/reservations/${reservationIds}`)
}

export function getGroupMembers(groupId) {
  return axios.get(`${BASE_GROUPS_PATH}/${groupId}/members`)
}

export function updateGroupMember(groupId, memberCisId, groupMemberUpdateProperties) {
  return axios.post(`${BASE_GROUPS_PATH}/${groupId}/members/${memberCisId}`, groupMemberUpdateProperties)
}

export async function deleteGroupMember(groupId, memberCisId) {
  return axios.delete(`${BASE_GROUPS_PATH}/${groupId}/members/${memberCisId}`)
}
